import React from "react";
import { makeStyles } from "@material-ui/core";
import Login from "../../components/Login";
import backGround from "../../assets/ADM/background.png";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${backGround})`,
    height: "100%",
    width: "100%",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
}));

export default function Admin() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Login />
    </div>
  );
}
